import Vue from 'vue'

const getCategories = (category_ids, categories, customCategories) => {
  if (!category_ids.length) {
    return 'Uncategorized'
  }

  const categoryIds = _.isString(category_ids)
        ? JSON.parse(category_ids)
        : category_ids

  const ids = categoryIds.map(id => Number.parseInt(id))
  const categoryNames = []

  ids.forEach(id => {
    const customCategory = customCategories.find(category => category.id === id)

    if (customCategory) {
      categoryNames.push(customCategory.description)
    }
  })

  ids.forEach(id => {
    const category = categories.find(category => category.id === id)

    if (category) {
      categoryNames.push(Vue.options.filters.category(category.description))
    }
  })

  if (!categoryNames.length) {
    return 'Uncategorized'
  }

  return categoryNames.join(', ')
}

export default getCategories